__turbopack_context__.v({
  "descriptionPolicy": "style-module__bjmMAW__descriptionPolicy",
  "img": "style-module__bjmMAW__img",
  "privacy": "style-module__bjmMAW__privacy",
  "privacyBanner": "style-module__bjmMAW__privacyBanner",
});
